import React, { Component } from 'react';
import axios from '../../shared/axios/axios';
import newAxios from '../../shared/axios/new-api-axios';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader/root';

import moment from 'moment';

import { Button, Spin, Modal, Space, notification } from 'antd';

import * as sharedActions from '../../shared/store/actions';
import * as signatureActions from '../signature/store/actions';
import * as actions from './store/actions';

import withErrorHandler from '../../hoc/withErrorHandler';

import PdfPrefillDataSourcesSelectorForm from './pdf-prefill-data-sources-selector-form';
import { PdfEditorComponent } from '../../shared/components/pdf-editor';
import AdditionalFiles from './additionalFiles';
import { isArray, isEmpty } from 'lodash';
import { isGuid } from '../../shared/utils';

import './styles.less';

let root;

class FormEditorComponent extends Component {
  state = {
    showSignatureOnPdf: false,
    signatureSaveCallback: undefined,
    formSaveCallback: undefined,
    initialFormValues: {
      formName: `(${moment(new Date()).format('MM/DD/YYYY')})`,
      policyIds: isGuid(this.props.policyId) ? [this.props.policyId] : undefined,
      automobileLiabilityCoverageSectionType: 0,
    },
    initialFormValuesLoaded: false,
    isUserForm: false,
    originalFileId: undefined,
    formClearCallback: undefined,
    getFilterData: undefined,
    additionalFilesProps: [],
    prefilledFormDataServer: undefined,
    prefilledFormDataLocal: undefined,
    isOriginalAcord: false,
    formParameters: undefined,
    signatureBytes: undefined,
    isCustomForm: false,
    appendFilesProps: [],
    currentFormDataSource: {},
    isAppendFileListChange: { change: false },
    isAppendFileListDataSourceChange: { change: false },
    isAdditionalFileListChange: { change: false },
    isAdditionalFileListDataSourceChange: { change: false },
    acordNameList: [],
    mainAcordName: '',
  };

  componentDidMount() {
    const { initialFormValues } = this.state;
    const { getFormParameters, rootContainer, getPermissions, formId, policyId, quoteRequestId } = this.props;

    root = rootContainer;

    getPermissions();

    getFormParameters({ formId, policyId, quoteRequestId }).then((result) => {
      if (result) {
        this.setState({ formParameters: result });

        const data = {
          ...initialFormValues,
          formName: result.formName + (result.isUserForm ? '' : ` (${moment(new Date()).format('MM/DD/YYYY')})`),
        };

        this.setState({ mainAcordName: result.formName });

        if (result.userFormPolicyRefIds && isArray(result.userFormPolicyRefIds) && !isEmpty(result.userFormPolicyRefIds)) {
          data.policyIds = result.userFormPolicyRefIds;
        }

        if (result.isUserForm === false && !isGuid(quoteRequestId)) {
          this.setState({ isOriginalAcord: true });
        }

        this.setState(
          {
            initialFormValues: data,
            isUserForm: result.isUserForm,
            originalFileId: result.originalFileId,
            isCustomForm: result.isCustomForm,
          },
          () => {
            this.setState({ initialFormValuesLoaded: true });
          },
        );
      }
    });
  }

  setAcordNameList = (value) => {
    this.setState({ acordNameList: value });
  };

  addAcordNameToList = (value) => {
    const { acordNameList } = this.state;

    if (!acordNameList.includes(value)) {
      acordNameList.push(value);
    }

    this.setState({ acordNameList: [...acordNameList] });
  };

  removeAcordNameToList = (value) => {
    const { acordNameList } = this.state;

    if (acordNameList.includes(value)) {
      acordNameList.splice(acordNameList.indexOf(value), 1);
    }

    this.setState({ acordNameList });
  };

  setShowSignatureOnPdf = (value) => {
    this.setState({ showSignatureOnPdf: value });
  };

  setSignatureSaveCallback = (value) => {
    this.setState({ signatureSaveCallback: value });
  };

  registerFormSaveCallback = (value) => {
    this.setState({ formSaveCallback: value });
  };

  registerFormClearCallback = (value) => {
    this.setState({ formClearCallback: value });
  };

  getFormBytes = async (formDataSource) => {
    const { getPrefilledForm, formId, policyId, contactId, quoteRequestId, rootContainer } = this.props;

    const { prefilledFormDataLocal, isUserForm, originalFileId, isCustomForm, formSaveCallback } = this.state;

    const fileDataBytes = isUserForm && typeof formSaveCallback === 'function' ? Array.from(new Uint8Array(await formSaveCallback())) : undefined;

    if (isUserForm && prefilledFormDataLocal?.defaultFilled === true && (!isArray(fileDataBytes) || isEmpty(fileDataBytes))) {
      Modal.info({
        getContainer: rootContainer,
        title: 'File is not loaded',
        content: 'Please wait till the file is loaded',
      });

      return;
    }

    const data = {
      formDataSource: { ...formDataSource, isReset: undefined },
      previousVersionFormDataSource: prefilledFormDataLocal?.previousVersionFormDataSource,
      formId: formId,
      truckingCompanyId: contactId,
      policyId: policyId,
      quoteRequestId: quoteRequestId,
      defaultFilled: prefilledFormDataLocal?.defaultFilled,
      formFieldNames: prefilledFormDataLocal?.formFieldNames,
      currentFileData: prefilledFormDataLocal?.currentFileData,
      parentFileData: prefilledFormDataLocal?.parentFileData,
      fileDataBytes: fileDataBytes,
      isReset: formDataSource.isReset,
    };

    getPrefilledForm({ data, isUserForm, originalFileId, isCustomForm }).then((x) => {
      this.setState({ prefilledFormDataServer: { ...x }, prefilledFormDataLocal: { ...x } });
      this.setState({ currentFormDataSource: formDataSource });

      this.validateAppendFiles(
        x.previousVersionFormDataSource?.appendFileDataList,
        formDataSource,
        x.previousVersionFormDataSource?.isAppendFileDataListChange,
      );

      this.validateAdditionalFiles(formDataSource);
    });
  };

  validateAppendFiles = (appendFileDataList, formDataSource, isAppendFileDataListChange) => {
    let newAppendFilesProps = [];
    if (isAppendFileDataListChange === true) {
      if (appendFileDataList) {
        for (const [key, value] of Object.entries(appendFileDataList)) {
          for (const arrayValueItem of value) {
            newAppendFilesProps.push({
              formId: key,
              dataSourceValues: { ...formDataSource, ...arrayValueItem },
              fileSaveCallback: undefined,
              appendDataSourceValues: arrayValueItem,
              fileClearCallback: undefined,
            });
          }
        }
      }

      this.setState({ appendFilesProps: newAppendFilesProps, isAppendFileListChange: { change: true } });
    } else {
      newAppendFilesProps = this.state.appendFilesProps.slice();

      newAppendFilesProps.forEach((x) => (x.dataSourceValues = { ...formDataSource, ...x.appendDataSourceValues }));

      this.setState({ appendFilesProps: newAppendFilesProps, isAppendFileListDataSourceChange: { change: true } });
    }
  };

  validateAdditionalFiles = (formDataSource) => {
    let newAdditionalFilesProps = this.state.additionalFilesProps.slice();

    newAdditionalFilesProps.forEach((x) => (x.dataSourceValues = formDataSource));

    this.setState({ additionalFilesProps: newAdditionalFilesProps, isAdditionalFileListDataSourceChange: { change: true } });
  };

  clearFormFields = (callback) => {
    const { prefilledFormDataLocal } = this.state;

    if (prefilledFormDataLocal?.previousVersionFormDataSource) {
      prefilledFormDataLocal.previousVersionFormDataSource = { defaultFilled: prefilledFormDataLocal.previousVersionFormDataSource.defaultFilled };
    }

    if (typeof this.state.formClearCallback === 'function') {
      this.state.formClearCallback(() => (typeof callback === 'function' ? callback() : undefined));
    }

    this.state.additionalFilesProps.forEach((x) => (typeof x.fileClearCallback === 'function' ? x.fileClearCallback() : undefined));

    this.setState({ appendFilesProps: [] });
  };

  registerGetFilterDataCallback = (value) => {
    this.setState({ getFilterData: value });
  };

  setSignatureId = (value) => {
    this.props.getSignatureBytes(value).then((x) => {
      this.setState({ signatureBytes: x });
      this.setShowSignatureOnPdf(true);
    });
  };

  onSaveSignatureClick = () => {
    this.state.signatureSaveCallback();
    this.setShowSignatureOnPdf(false);
  };

  onCancelSignatureClick = () => {
    this.setState({ signatureBytes: undefined });
    this.setShowSignatureOnPdf(false);
  };

  onCancelClick = (redirectUrl) => {
    const { rootContainer } = this.props;

    Modal.confirm({
      getContainer: rootContainer,
      title: 'All changes will be lost. Are you sure you want to close?',
      okText: 'Yes',
      cancelText: 'No',
      onOk() {
        if (redirectUrl) {
          window.location.href = redirectUrl;
        }
      },
    });
  };

  onSaveClick = (redirectUrl) => {
    const { formSaveCallback, additionalFilesProps, appendFilesProps } = this.state;

    if (
      typeof formSaveCallback === 'function' &&
      ((isArray(additionalFilesProps) && !isEmpty(additionalFilesProps)) || (isArray(appendFilesProps) && !isEmpty(appendFilesProps)))
    ) {
      const registerFileSavePromises = [...additionalFilesProps, ...appendFilesProps]
        .filter((x) => typeof x.fileSaveCallback === 'function')
        .map((fileProp) => {
          return fileProp.fileSaveCallback();
        });

      Promise.all(registerFileSavePromises)
        .then((fileSaveResults) => {
          return formSaveCallback().then((formDataArray) => {
            this.handleSaveForm({
              formDataArray,
              redirectUrl,
              appendFileList: fileSaveResults,
            });
          });
        })
        .catch((err) => {
          console.error('Error saving files or form:', err);

          notification.error({
            message: 'Error',
            top: 55,
            duration: 10,
            getContainer: rootContainer,
            description: `Error saving files`,
          });
        });
    } else if (typeof formSaveCallback === 'function') {
      formSaveCallback()
        .then((formDataArray) => {
          this.handleSaveForm({ formDataArray, redirectUrl, appendFileList: undefined });
        })
        .catch((err) => {
          console.error('Error saving files or form:', err);

          notification.error({
            message: 'Error',
            top: 55,
            duration: 10,
            getContainer: rootContainer,
            description: `Error saving file`,
          });
        });
    }
  };

  handleSaveForm = ({ formDataArray, redirectUrl, appendFileList }) => {
    const { isUserForm, getFilterData, originalFileId } = this.state;
    const { rootContainer, savePdfFormLoading, savePdfForm, formId, agentId, policyId, contactId } = this.props;

    Modal.confirm({
      getContainer: rootContainer,
      title: `Are you sure you want to ${isUserForm ? 'update' : 'save'}?`,
      okText: 'Yes',
      cancelText: 'No',
      confirmLoading: savePdfFormLoading,
      okButtonProps: { disabled: savePdfFormLoading },
      onOk() {
        let filterData;

        if (typeof getFilterData === 'function') {
          filterData = getFilterData();
        } else {
          throw new Error('getFilterData must be defined');
        }

        if (isEmpty(filterData.formName) || filterData.formName.length > 199 || filterData.formName.length < 1) {
          return notification.error({
            message: 'Error',
            top: 55,
            duration: 10,
            getContainer: rootContainer,
            description: `Form name is not valid`,
          });
        }

        const formData = Array.from(new Uint8Array(formDataArray));

        const appendFileDataList = appendFileList ? appendFileList.map((x) => Array.from(new Uint8Array(x))) : undefined;

        return savePdfForm({
          formName: filterData.formName,
          policyIds: filterData.policyIds ? filterData.policyIds.filter((x) => isGuid(x)) : undefined,
          formData,
          appendFileDataList,
          userFileId: isUserForm ? formId : undefined,
          originalFileId: originalFileId,
          contactId,
          policyId,
          agentId,
        }).then(() => {
          notification.success({
            message: 'Success',
            top: 55,
            duration: 10,
            getContainer: rootContainer,
            description: `PDF form was successfully ${isUserForm ? 'updated' : 'saved'}`,
          });

          if (redirectUrl) {
            window.location.href = redirectUrl;
          }
        });
      },
    });
  };

  onAppendFormSelected = (item) => {
    const { currentFormDataSource } = this.state;

    let newAdditionalFilesProps = this.state.additionalFilesProps.slice();

    newAdditionalFilesProps.push({
      formId: item.key,
      formName: item.value,
      dataSourceValues: currentFormDataSource,
      fileSaveCallback: undefined,
      fileClearCallback: undefined,
      appendDataSourceValues: undefined,
    });

    this.setState({ additionalFilesProps: newAdditionalFilesProps });

    this.addAcordNameToList(item.value);
  };

  render() {
    const {
      rootContainer,
      permissions,
      prefilledFormLoading,
      signatureBytesLoading,
      formParametersLoading,
      savePdfFormLoading,
      policyId,
      contactId,
      redirectUrl,
    } = this.props;

    const {
      showSignatureOnPdf,
      initialFormValues,
      formParameters,
      initialFormValuesLoaded,
      isUserForm,
      additionalFilesProps,
      prefilledFormDataServer,
      isOriginalAcord,
      signatureBytes,
      appendFilesProps,
      isAppendFileListDataSourceChange,
      isAdditionalFileListDataSourceChange,
      isAppendFileListChange,
      isAdditionalFileListChange,
      acordNameList,
      mainAcordName,
    } = this.state;

    return !initialFormValuesLoaded ? (
      <Spin spinning={true} />
    ) : (
      <div className="form-editor">
        <div className="additional-controls-container">
          <PdfPrefillDataSourcesSelectorForm
            rootContainer={rootContainer}
            triggerFormReload={this.getFormBytes}
            contactId={contactId}
            clearFormFields={this.clearFormFields}
            initialFormValues={initialFormValues}
            policyId={policyId}
            permissions={permissions}
            registerGetFilterDataCallback={this.registerGetFilterDataCallback}
            formParameters={formParameters}
            formParametersLoading={formParametersLoading}
            setSignatureId={this.setSignatureId}
            showSignatureOnPdf={showSignatureOnPdf}
            onSaveSignatureClick={this.onSaveSignatureClick}
            onCancelSignatureClick={this.onCancelSignatureClick}
            onAppendFormSelected={this.onAppendFormSelected}
            isOriginalAcord={isOriginalAcord}
            acordNameList={acordNameList}
            addAcordNameToList={this.addAcordNameToList}
            mainAcordName={mainAcordName}
            isUserForm={isUserForm}
          />
        </div>

        <PdfEditorComponent
          fileBytes={prefilledFormDataServer?.fileBytes}
          clearFieldNames={prefilledFormDataServer?.previousVersionFormDataSource?.mappedFieldName?.clearFieldNames}
          fieldsToFill={prefilledFormDataServer?.previousVersionFormDataSource?.mappedFieldName?.fieldsToFill}
          registerFormSaveCallback={this.registerFormSaveCallback}
          registerFormClearCallback={this.registerFormClearCallback}
          rootContainer={rootContainer}
          loading={prefilledFormLoading || signatureBytesLoading}
          showSignatureOnPdf={showSignatureOnPdf}
          registerSignatureSaveCallback={this.setSignatureSaveCallback}
          signatureBytes={signatureBytes}
        />

        {isArray(appendFilesProps) && !isEmpty(appendFilesProps) && isOriginalAcord
          ? appendFilesProps.map((x, index) => (
              <div key={index}>
                <AdditionalFiles
                  rootContainer={rootContainer}
                  formId={x.formId}
                  policyId={policyId}
                  insuredId={contactId}
                  registerFileSaveCallback={(saveFunction) => (x.fileSaveCallback = saveFunction)}
                  onDeleteAppendFile={() =>
                    this.setState({ appendFilesProps: appendFilesProps.filter((y) => y !== x), isAppendFileListChange: { change: true } })
                  }
                  dataSourceValues={x.dataSourceValues}
                  updateFormParameters={(x) => this.setState({ formParameters: { ...x } })}
                  formParameters={formParameters}
                  registerFormClearCallback={(clearFunction) => (x.fileClearCallback = clearFunction)}
                  refreshFile={isAppendFileListDataSourceChange}
                  generateFile={isAppendFileListChange}
                />
              </div>
            ))
          : null}

        {isArray(additionalFilesProps) && !isEmpty(additionalFilesProps) && isOriginalAcord
          ? additionalFilesProps.map((x, index) => (
              <div key={index}>
                <AdditionalFiles
                  rootContainer={rootContainer}
                  formId={x.formId}
                  policyId={policyId}
                  insuredId={contactId}
                  registerFileSaveCallback={(saveFunction) => (x.fileSaveCallback = saveFunction)}
                  onDeleteAppendFile={() => {
                    this.setState({
                      additionalFilesProps: additionalFilesProps.filter((y) => y !== x),
                      isAdditionalFileListChange: { change: true },
                    });

                    this.removeAcordNameToList(x.formName);
                  }}
                  dataSourceValues={x.dataSourceValues}
                  updateFormParameters={(x) => this.setState({ formParameters: { ...x } })}
                  formParameters={formParameters}
                  registerFormClearCallback={(clearFunction) => (x.fileClearCallback = clearFunction)}
                  refreshFile={isAdditionalFileListDataSourceChange}
                  generateFile={isAdditionalFileListChange}
                />
              </div>
            ))
          : null}

        <div className="save-cancel-actions">
          <Space>
            <Button onClick={() => this.onCancelClick(redirectUrl)}>Cancel</Button>
            <Button
              onClick={() => this.onSaveClick(redirectUrl)}
              type="primary"
              loading={savePdfFormLoading || prefilledFormLoading || signatureBytesLoading || formParametersLoading || !formParameters}
              disabled={showSignatureOnPdf}
            >
              {isUserForm ? 'Update' : 'Save'}
            </Button>
          </Space>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    permissions: state.permissions.permissions,
    prefilledFormLoading: state.formEditor.prefilledFormLoading,
    signatureBytesLoading: state.signature.signatureBytesLoading,
    formParametersLoading: state.formEditor.formParametersLoading,
    savePdfFormLoading: state.formEditor.savePdfFormLoading,
    acordLookup: state.formEditor.acordLookup,
    acordLookupLoading: state.formEditor.acordLookupLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPermissions: () => dispatch(sharedActions.getPermissions()),
    getPrefilledForm: (pageRequest) => dispatch(actions.getPrefilledForm(pageRequest)),
    savePdfForm: (formData) => dispatch(actions.savePdfForm(formData)),
    getFormParameters: (params) => dispatch(actions.getFormParameters(params)),
    getSignatureBytes: (signatureId) => dispatch(signatureActions.getSignatureBytes(signatureId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(hot(withErrorHandler(FormEditorComponent, axios, root, newAxios)));
